import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const DummyMenu = () => (
  <div className="text-size-body-sm mr-1">
    {Array.from({ length: 13 }).map((_, index) => (
      <div
        className="bg-color-grey mb-1 h-4.5 w-full"
        // eslint-disable-next-line @eslint-react/no-array-index-key
        key={index}
      />
    ))}
  </div>
);
export const DummyProducts = () => (
  <div className="flex w-full flex-wrap justify-between gap-2">
    {Array.from({ length: 8 }).map((_, index) => (
      <div
        className="flex w-1/5 flex-col items-center gap-y-1"
        // eslint-disable-next-line @eslint-react/no-array-index-key
        key={index}
      >
        <Skeleton className="bg-color-grey h-[13rem] w-4/5" />
        <Skeleton className="bg-color-grey h-2 w-[30%]" />
        <Skeleton className="bg-color-grey h-2 w-full" />
        <Skeleton className="bg-color-grey h-2 w-1/2" />
      </div>
    ))}
  </div>
);
